module.exports = __webpack_public_path__ + "img/add.98755ff4.svg";